function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104 94"
}, props), React.createElement("path", {
  d: "M51.19 75.07s-6.855 1.018-13.89-7.332M71.565 72.804S57.19 90.32 43.128 83.14M41.992 72.1s-3.462 8.928-11.124 3.004",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M65.768 23.432l.854 5.643c.345 2.274 2.428 3.726 4.481 3.123l5.1-1.502-3.079 4.65c-1.237 1.867-.713 4.49 1.128 5.635l4.583 2.843-5.21.925c-2.099.373-3.439 2.63-2.882 4.854l1.386 5.525-4.293-3.336c-1.723-1.34-4.144-.772-5.201 1.223l-2.625 4.964-.854-5.652c-.344-2.274-2.428-3.725-4.48-3.123l-5.1 1.502 3.078-4.65c1.238-1.867.713-4.49-1.128-5.635l-4.583-2.843 5.21-.925c2.1-.373 3.439-2.63 2.883-4.854l-1.387-5.524 4.293 3.335c1.724 1.34 4.144.772 5.202-1.222l2.624-4.965v.009z",
  fill: "#357287"
}), React.createElement("path", {
  d: "M13.508 65.201V28.795C9.6 33.82 7.343 40.243 7.343 46.998c0 6.755 2.256 13.18 6.165 18.203z",
  fill: "#C0D2D6"
}), React.createElement("path", {
  d: "M102 85.915l-14.242-7.74c-3.322-1.807-7.286-1.085-9.996 1.664C70.335 87.375 60.355 92 49.379 92c-12.698 0-24.073-6.177-31.688-15.902C8.322 70.369 2 59.48 2 46.997 2 34.515 8.322 23.636 17.683 17.9",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M17.676 17.907C25.736 7.605 38.005 1.291 51.605 2.064c20.5 1.162 37.312 18.729 39.138 40.877.337 4.057.164 8.011-.447 11.796-.658 4.074 1.27 8.121 4.677 9.98L102 68.544",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M30.148 28.795s6.22 6.72 6.22 18.712c0 11.99-6.84 21.716-15.284 21.716V35.109c0-7.876 3.556-15.343 9.667-19.603 5.97-4.159 13.122-6.416 19.859-6.034a32.496 32.496 0 0112.268 3.182M90.853 71.217L102 77.022",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));